import { PotentialAnswerType, QuestionInlineType } from '@data/types';
import React from 'react';
import { hash } from 'utilities/helper';

import Answer from './Answer';
import QuestionMessage from './QuestionMessage';
import QuestionText from './QuestionText';

interface Props extends QuestionInlineType {
  as?: keyof JSX.IntrinsicElements;
}

const QuestionInline: React.FC<Props> = ({
  as: Component = 'div',
  htmlContent = '',
  question,
  answers,
  index = 0,
  selectedAnswers,
  setSelectedAnswers,
  id,
}) => {
  // Transform answers before sending to button functions
  const transformedAnswers: PotentialAnswerType[] = answers.map((answer) => ({
    type: answer?.type || '',
    options: answer?.options || [],
  }));

  return (
    <Component className="w-full" id={id}>
      <div className="relative flex flex-col">
        {htmlContent && (
          <div
            className="prose prose-h2:font-lightNormal prose-h2:text-xs prose-h2:bg-blue-light prose-h2:text-blue prose-h2:rounded-tl-lg prose-h2:rounded-br-lg prose-h2:mb-4 prose-h2:inline-block prose-h2:uppercase prose-h2:px-4 prose-h2:pb-1 prose-h2:pt-3 prose-h2:inline-block prose-h3:font-lightNormal prose-h3:text-base prose-p:text-sm prose-p:font-lighterNormal prose-p:leading-5"
            dangerouslySetInnerHTML={
              htmlContent ? { __html: htmlContent } : undefined
            }
          ></div>
        )}
        <QuestionText text={question} />
        <QuestionMessage answers={transformedAnswers} />
        <div className="relative">
          <div className="overflow-hidden mb-4">
            <div className="relative mb-8 lg:mb-16">
              <ul className="flex flex-col gap-4">
                {answers.map((item, answerIndex) => (
                  <li key={hash([item, answerIndex])} className="relative">
                    <Answer
                      {...item}
                      questionIndex={index}
                      answerIndex={answerIndex}
                      questionText={question}
                      setSelectedAnswers={setSelectedAnswers}
                      selectedAnswers={selectedAnswers}
                      showLabels={true}
                    />
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </Component>
  );
};

export default QuestionInline;
